const VIDEO_EXT = /\.(mp4|webm|ogg|ogv|mov|mkv|m4v)$/i;

/**
 * True if the asset should be treated as video (browser can play via <video>).
 * Handles application/octet-stream and missing mime when the filename has a known video extension.
 */
export function isVideoMimeOrExtension(mimeType, filename) {
  if (mimeType?.startsWith('video/')) return true;
  if (!filename || !VIDEO_EXT.test(filename)) return false;
  if (!mimeType || mimeType === 'application/octet-stream') return true;
  return false;
}
